import React from 'react'
import { Link } from 'gatsby'
import { injectIntl } from 'react-intl';

import NextIcon from "../../../assets/next.svg"
import * as S from './Blog.styled'
import generateLink from '../../../utils/generateLink';

const Blog = ({ data, intl }) => {
  const urlPost = (post) => (post.node.fields.langKey !== 'en' ? `/${post.node.fields.langKey}` : '') + '/blog/' + post.node.frontmatter.slug

  return (
    <S.Blog>
      <div className="container">
        <Link to={generateLink({ link: '/blog', locale: intl.locale })} className="title">
          <span>{intl.messages.blog.title}</span>
          <NextIcon />
        </Link>

        <div className="last-posts">
          <div className="last-posts__title">{intl.messages.blog.lastposts}</div>
          <div className="last-posts__grid">
            {data.allMarkdownRemark.edges.map((post, index) => (
              <div key={index} className="post">
                <Link to={urlPost(post)}>
                  <div className="post__image-feature" style={{ backgroundImage: `url(${post.node.frontmatter.shareImage})` }} />
                  <div className="post__title">{post.node.frontmatter.title}</div>
                  <div className="post__posted">{intl.messages.blog.by} {data.site.siteMetadata.authors[post.node.frontmatter.author].name} {intl.messages.blog.in} <strong>{post.node.frontmatter.date}</strong></div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </S.Blog>
  )
}

export default injectIntl(Blog);